<template>
    <div class="w-100">
        <template v-if="!isMobile">
            <LoadingStandings v-if="type === 'standings'" />
            <div class="display-flex-center" v-else>
                <!-- <van-loading /> -->
                <img
                    src="../../../static/images/icons/aspn_icon/loading/loading.gif"
                    class="loading-size"
                />
            </div>
        </template>
        <template v-else>
            <LoadingNews1 v-if="type === 'news-1'" />
            <LoadingNews2 v-else-if="type === 'news-2'" />
            <LoadingNewsDetails v-else-if="type === 'news-details'" />
            <LoadingStandings v-else-if="type === 'standings'" />
            <LoadingHomeMatchCard v-else-if="type === 'home-match-card'" />
            <LoadingHomeMatchCard
                v-else-if="type === 'league-match-card'"
                type="league"
            />
            <LoadingMatchDetails
                v-else-if="type === 'match-details'"
                :page="page"
            />
            <LoadingSquad v-else-if="type === 'squad'" />
            <LoadingTransfer v-else-if="type === 'transfer'" />
            <LoadingFilter v-else-if="type === 'filter'" />
            <LoadingPlayer v-else-if="type === 'player'" />
            <img
                v-else
                src="../../../static/images/icons/aspn_icon/loading/loading.gif"
                class="loading-size"
                />
        </template>
    </div>
</template>

<script>
// import LoadingGif from "../../../static/images/icons/aspn_icon/loading/loading.gif";
import { mapGetters } from "vuex";
import LoadingNews1 from "./LoadingNews1.vue";
import LoadingNews2 from "./LoadingNews2.vue";
import LoadingNewsDetails from "./LoadingNewsDetails.vue";
import LoadingStandings from "./LoadingStandings.vue";
import LoadingHomeMatchCard from "./LoadingHomeMatchCard.vue";
import LoadingSquad from "./LoadingSquad.vue";
import LoadingTransfer from "./LoadingTransfer.vue";
import LoadingMatchDetails from "./LoadingMatchDetails.vue";
import LoadingFilter from "./LoadingFilter.vue";
import LoadingPlayer from "./LoadingPlayer.vue";
export default {
    name: "Loading",
    props: {
        type: String,
        page: String,
    },
    components: {
        LoadingNews1,
        LoadingNews2,
        LoadingNewsDetails,
        LoadingStandings,
        LoadingHomeMatchCard,
        LoadingSquad,
        LoadingTransfer,
        LoadingMatchDetails,
        LoadingFilter,
        LoadingPlayer,
    },
    computed: {
        ...mapGetters(["isMobile"]),
    },
};
</script>

<style scoped>
.loading-size {
    width: 40px;
}
</style>
